import { render, staticRenderFns } from "./Promodal.vue?vue&type=template&id=a085a160&scoped=true"
import script from "./Promodal.vue?vue&type=script&lang=ts"
export * from "./Promodal.vue?vue&type=script&lang=ts"
import style0 from "./Promodal.vue?vue&type=style&index=0&id=a085a160&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a085a160",
  null
  
)

/* custom blocks */
import block0 from "./Promodal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports